//On host - Contra Team
const imageRoutes = 'https://shop-be.djurdjevic.eu.org/img/';

// const imageRoutes = 'http://localhost:5000/img/';

export default imageRoutes;
